import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "currentColor",
  version: "1.1",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 22.944q0 2.464 1.76 4.224l3.072 3.104Q6.592 32 9.056 32t4.256-1.728L16 27.296q1.376-1.344 1.664-3.232t-.512-3.552l-6.784 6.784q-.576.576-1.408.576t-1.44-.576L4.704 24.48q-.576-.608-.576-1.408t.576-1.408l6.784-6.816q-1.632-.8-3.52-.512T4.704 16L1.76 18.72Q0 20.48 0 22.944zm9.792-2.688q0 .832.576 1.408t1.408.576 1.408-.576l8.48-8.48q.576-.576.576-1.408t-.576-1.408q-.608-.576-1.44-.576t-1.408.576l-8.448 8.48q-.576.576-.576 1.408zm4.544-12.288q-.288 1.888.512 3.552l6.816-6.816q.576-.576 1.408-.576t1.408.576l2.816 2.848q.576.576.576 1.408t-.576 1.408l-6.784 6.784q1.632.832 3.52.512T27.296 16l2.944-2.944Q32 11.296 32 8.832t-1.76-4.256L27.424 1.76Q25.664 0 23.2 0t-4.256 1.76L16 4.704q-1.344 1.376-1.664 3.264z" }, null, -1)
  ])))
}
export default { render: render }